import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-footer-navigation',
  templateUrl: './footer-navigation.component.html',
  styleUrls: ['./footer-navigation.component.scss'],
})
export class FooterNavigationComponent implements OnInit {
  @Input() showFooter: boolean;

  constructor() { }

  ngOnInit() {  }


}
